import React from 'react';
import { Helmet } from 'react-helmet-async';
import { AppHeader } from '../components/AppHeader';
import { AppFooter } from '../components/AppFooter';
import { useScreenInit } from '../useScreenInit';
import { Building } from 'lucide-react';
import { Input } from '../components/Input';
import { Textarea } from '../components/Textarea';
import { Label } from '../components/Label';
import { Button } from '../components/Button';
export function PartnerFacility() {
  useScreenInit('PartnerFacility');
  return <div className="min-h-screen bg-slate-50 flex flex-col" data-id="element-1155">
      <Helmet data-id="element-1156">
        <title data-id="element-1157">Facility Partner Sign-up | Affordable Medical Tourism</title>
        <meta name="description" content="Join our network of elite medical facilities. Partner with Kosansh Solutions Inc to reach international patients seeking high-quality care." data-id="element-1158" />
      </Helmet>

      <AppHeader data-id="element-1159" />

      <main className="flex-1 w-full max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-id="element-1160">
        <div className="text-center mb-12" data-id="element-1161">
          <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl mb-6" data-id="element-1162">
            Facility Partner Sign-up
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-1163">
            We partner with internationally accredited hospitals and specialized
            clinics to provide world-class care to patients bypassing long wait
            times in their home countries.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden flex flex-col" data-id="element-1164">
          <div className="p-8 bg-blue-900 text-white flex items-center gap-4" data-id="element-1165">
            <Building className="w-8 h-8 text-blue-300" data-id="element-1166" />
            <div data-id="element-1167">
              <h2 className="text-2xl font-semibold" data-id="element-1168">Facility Application</h2>
              <p className="text-blue-200 text-sm mt-1" data-id="element-1169">
                For Hospitals and Clinics
              </p>
            </div>
          </div>
          <div className="p-8 flex-1" data-id="element-1170">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-1171">
              <div className="space-y-2" data-id="element-1172">
                <Label htmlFor="facilityName" data-id="element-1173">Facility Name</Label>
                <Input id="facilityName" placeholder="e.g. General Hospital" data-id="element-1174" />
              </div>
              <div className="space-y-2" data-id="element-1175">
                <Label htmlFor="facilityCountry" data-id="element-1176">Country</Label>
                <Input id="facilityCountry" placeholder="e.g. Mexico" data-id="element-1177" />
              </div>
              <div className="space-y-2" data-id="element-1178">
                <Label htmlFor="accreditations" data-id="element-1179">Key Accreditations</Label>
                <Input id="accreditations" placeholder="e.g. JCI, ISO 9001" data-id="element-1180" />
              </div>
              <div className="space-y-2" data-id="element-1181">
                <Label htmlFor="facilityContact" data-id="element-1182">Contact Person Name</Label>
                <Input id="facilityContact" placeholder="Full Name" data-id="element-1183" />
              </div>
              <div className="space-y-2" data-id="element-1184">
                <Label htmlFor="facilityPhone" data-id="element-1185">Phone Number</Label>
                <Input id="facilityPhone" type="tel" placeholder="+1 (555) 000-0000" data-id="element-1186" />
              </div>
              <div className="space-y-2" data-id="element-1187">
                <Label htmlFor="facilityMessage" data-id="element-1188">Message</Label>
                <Textarea id="facilityMessage" placeholder="Tell us about your specialties, total beds, and international patient program..." className="min-h-[100px]" data-id="element-1189" />
              </div>
              <Button type="submit" className="w-full" size="lg" data-id="element-1190">
                Submit Application
              </Button>
            </form>
          </div>
        </div>
      </main>

      <AppFooter data-id="element-1191" />
    </div>;
}